import { render, staticRenderFns } from "./EnvelopesManager.vue?vue&type=template&id=4af8eb15&scoped=true"
import script from "./EnvelopesManager.vue?vue&type=script&lang=js"
export * from "./EnvelopesManager.vue?vue&type=script&lang=js"
import style0 from "./EnvelopesManager.vue?vue&type=style&index=0&id=4af8eb15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af8eb15",
  null
  
)

export default component.exports